"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyDetailAddressParts$ = exports.CompanyDetailAddressParts$outboundSchema = exports.CompanyDetailAddressParts$inboundSchema = void 0;
exports.companyDetailAddressPartsToJSON = companyDetailAddressPartsToJSON;
exports.companyDetailAddressPartsFromJSON = companyDetailAddressPartsFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.CompanyDetailAddressParts$inboundSchema = z.object({
    address_line1: z.nullable(z.string()),
    address_line2: z.nullable(z.string()),
    country: z.nullable(z.string()),
    county: z.nullable(z.string()),
    po_box: z.nullable(z.string()),
    post_code: z.nullable(z.string()),
    post_town: z.nullable(z.string()),
    premises: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "address_line1": "addressLine1",
        "address_line2": "addressLine2",
        "po_box": "poBox",
        "post_code": "postCode",
        "post_town": "postTown",
    });
});
/** @internal */
exports.CompanyDetailAddressParts$outboundSchema = z.object({
    addressLine1: z.nullable(z.string()),
    addressLine2: z.nullable(z.string()),
    country: z.nullable(z.string()),
    county: z.nullable(z.string()),
    poBox: z.nullable(z.string()),
    postCode: z.nullable(z.string()),
    postTown: z.nullable(z.string()),
    premises: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        addressLine1: "address_line1",
        addressLine2: "address_line2",
        poBox: "po_box",
        postCode: "post_code",
        postTown: "post_town",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CompanyDetailAddressParts$;
(function (CompanyDetailAddressParts$) {
    /** @deprecated use `CompanyDetailAddressParts$inboundSchema` instead. */
    CompanyDetailAddressParts$.inboundSchema = exports.CompanyDetailAddressParts$inboundSchema;
    /** @deprecated use `CompanyDetailAddressParts$outboundSchema` instead. */
    CompanyDetailAddressParts$.outboundSchema = exports.CompanyDetailAddressParts$outboundSchema;
})(CompanyDetailAddressParts$ || (exports.CompanyDetailAddressParts$ = CompanyDetailAddressParts$ = {}));
function companyDetailAddressPartsToJSON(companyDetailAddressParts) {
    return JSON.stringify(exports.CompanyDetailAddressParts$outboundSchema.parse(companyDetailAddressParts));
}
function companyDetailAddressPartsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.CompanyDetailAddressParts$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CompanyDetailAddressParts' from JSON`);
}
//# sourceMappingURL=companydetailaddressparts.js.map